import { render, staticRenderFns } from "./YoukeLaiyuan.vue?vue&type=template&id=6202166c&scoped=true&"
import script from "./YoukeLaiyuan.vue?vue&type=script&lang=js&"
export * from "./YoukeLaiyuan.vue?vue&type=script&lang=js&"
import style0 from "./YoukeLaiyuan.vue?vue&type=style&index=0&id=6202166c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6202166c",
  null
  
)

export default component.exports